import React from 'react';

    const gridGroup1 = [{
        link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Cyberpunk_2077_300x400.jpg",
        name: "Cyberpunk 2077" },
        {link: "https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Immortals_Fenyx_Rising_300x400.jpg", 
        name: "Immortals Fenyx Rising" },
        {link: "https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Destiny_2__The_Collection_1x.jpg", 
        name:"Destiny 2" }, 
        {link: "https://www.gstatic.com/stadia/gamers/landing_page/assets/games/assassinscreed_valhalla_1x.jpg", 
        name: "Assassin's Creed Valhalla"}, 
        {link: "https://www.gstatic.com/stadia/gamers/landing_page/assets/games/outcasters_1x.jpg", 
        name: "Outcasters" 
    }]


    const gridGroup2 = [{
        link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/ary_secretofseasons.jpg",
        name: "Ary and the Secret of Seasons" },
        {link: "https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Crayta_1x.jpg", 
        name: "Crayta" },
        {link: "https://www.gstatic.com/stadia/gamers/landing_page/assets/games/cthulhusaveschristmas_1x.jpg", 
        name:"Cthulhu Saves Christmas" }, 
        {link: "https://www.gstatic.com/stadia/gamers/landing_page/assets/games/elhijo_1x.jpg", 
        name: "El Hijo - A Wild West Tale"}, 
        {link: "https://www.gstatic.com/stadia/gamers/landing_page/assets/games/entertheguneon_1x.jpg", 
        name: "Enter the Gungeon" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/everspace_1x.jpg", 
        name:"Everspace" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/F12020_1x.jpg", 
        name:"F1 2020" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/figment_1x.jpg", 
        name:"Figment" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Gunsport_1x.jpg", 
        name:"Gunsport" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Hitman_1x.jpg",
         name:"Hitman 1" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/hotlinemiami_1x.jpg", 
        name:"Hotline Miami" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/human_fall_flat_1x.jpg", 
        name:"Human: Fall Flat" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/journey-savage_1x.jpg",
         name:"Journey to the Savage Planet: Employee of the Month Edition" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Kine_1x.jpg", 
        name:"Kine" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/laracroft_guardianoflight_1x.jpg", 
        name:"Lara Croft & the Guardian of Light" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/farcry_newdawn.jpg", 
        name:"Far Cry New Dawn" },
        { link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/farcry_5.jpg", 
        name:"Far Cry 5" 
    }]

const gridGroup3 = [{
    link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/monsterjam_steeltitans_1x.jpg", 
    name:"Monster Jam Steel Titans" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Orcs_Must-Die_3_1x.jpg", 
    name:"Orcs Must Die! 3" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/outcasters_1x.jpg", 
    name:"Outcasters" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/PlayerUnknown_s_Battlegrounds_1x.jpg", 
    name:"PlayerUnknown's Battlegrounds" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Republique-Keyart-Vertical_1x.jpg", 
    name:"Republique" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/secretneighbor_1x.jpg", 
    name:"Secret Neighbor" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Steamworld_Dig_1x.jpg", 
    name:"Steamworld Dig" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/SteamWorld_Dig_2_1x.jpg", 
    name:"SteamWorld Dig 2" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/SteamWorld_Heist_1x.jpg", 
    name:"SteamWorld Heist" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/SteamWorld_Quest__Hand_of_Gilgamech_1x.jpg", 
    name:"SteamWorld Quest: Hand of Gilgamech" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/assassinscreed_valhalla_1x.jpg", 
    name:"Assassins Creed Valhalla" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/assassinscreed_unity_1x.jpg", 
    name:"Assassins Creed Unity" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/assassinscreed_syndicate_1x.jpg", 
    name:"Assassins Creed Syndicate" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/assassinscreed_origins_1x.jpg", 
    name:"Assassins Creed Origins" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/assassinscreed_odyssey_1x.jpg", 
    name:"Assassins Creed Odyssey" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/AttackonTitan2_FinalBattle_1x.jpg", 
    name:"Attack on Titan 2: Final Battle" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Baldurs_Gate_3_300x400.jpg", 
    name:"Baldur's Gate 3" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Borderlands3_1x.jpg", 
    name:"Borderlands 3" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Cakebash_1x.jpg", 
    name:"Cake Bash" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Celeste_1x.jpg", 
    name:"Celeste" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/DarksidersGenesis_1x.jpg", 
    name:"Darksiders Genesis" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/deadbydaylight_1x.jpg", 
    name:"Dead by Daylight" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Destiny_2__The_Collection_1x.jpg", 
    name:"Destiny 2: The Collection" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Doom_1x.jpg", 
    name:"Doom" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/DOOM64_1x.jpg", 
    name:"DOOM 64" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/DoomEternal_1x.jpg", 
    name:"Doom Eternal" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/DRAGONBALLXENOVERSE2_1x.jpg", 
    name:"Dragon Ball Xenoverse 2" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Embr_1x.jpg", 
    name:"Embr" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/entertheguneon_1x.jpg", 
    name:"Enter the Gungeon" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/familyfeud_decades.jpg", 
    name:"Family Feud Decades" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/FootballManager2020_1x.jpg", 
    name:"Football Manager 2020" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Get_Packed_1x.jpg", 
    name:"Get Packed" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/GhostReconBreakpoint_1x.jpg", 
    name:"Ghost Recon Breakpoint" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/GWF_1x.jpg", 
    name:"Gods Will Fall" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/GRID_1x.jpg", 
    name:"GRID" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/hotlinemiami2_1x.jpg", 
    name:"Hotline Miami 2" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/immortalsfenyxrising_1x.jpg", 
    name:"Immortal Fenyx Rising" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/intothebreach_1x.jpg", 
    name:"Into the Breach" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Jotun_1x.jpg", 
    name:"Jotun: Valhalla Edition" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/JustDance2020_1x.jpg", 
    name:"Just Dance 2020" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/WWEbattlegrounds_1x.jpg", 
    name:"WWE Battlegrounds" },
    {link:"https://www.gstatic.com/stadia/gamers/landing_page/assets/games/Zombie_Army_4__Dead_War_1x.jpg", 
name:"Zombie Army 4: Dead War"  
}]

    export {gridGroup1, gridGroup2, gridGroup3}